module.exports = __webpack_public_path__ + "img/DS-J-18.24d40b02.svg";